var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 47,
    viewBox: "0 0 131 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2197 17.0484C88.1408 17.0484 107.886 19.0884 116.828 22.023V22.0093C116.828 22.0093 130.156 24.8449 130.439 35.1216C130.447 35.3779 130.441 35.6215 130.432 35.8531C130.434 35.9631 130.439 36.0734 130.439 36.1841C130.439 42.0554 126.631 46.8147 121.933 46.815V46.816H8.50684L8.06934 46.8013C3.57447 46.5167 0 41.8722 0 36.1841C9.01882e-05 32.6373 1.39103 29.4972 3.52734 27.566C6.54208 24.416 10.853 22.8708 12.8301 22.2916C21.3631 19.2136 41.6059 17.0484 65.2197 17.0484Z",
    fill: "#3C4858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2197 0C88.1408 1.17651e-05 107.886 2.03997 116.828 4.97461V4.96094C116.828 4.96094 130.156 7.79646 130.439 18.0732C130.447 18.3295 130.441 18.5731 130.432 18.8047C130.434 18.9147 130.439 19.025 130.439 19.1357C130.439 25.007 126.631 29.7663 121.933 29.7666V29.7676H8.50684L8.06934 29.7529C3.57447 29.4683 0 24.8238 0 19.1357C8.7946e-05 15.5889 1.39103 12.4488 3.52734 10.5176C6.54208 7.36763 10.853 5.82235 12.8301 5.24316C21.3631 2.16515 41.6059 0 65.2197 0Z",
    fill: "#FFDE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearthIcon);
export default __webpack_public_path__ + "static/media/hearth_icon.1eeff3f76eb56d33f1d9400cd09de426.svg";
export { ForwardRef as ReactComponent };